// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Kodchasan:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kodchasan-extralight {
  font-family: "Kodchasan", serif;
  font-weight: 200;
  font-style: normal;
}

.kodchasan-light {
  font-family: "Kodchasan", serif;
  font-weight: 300;
  font-style: normal;
}

.kodchasan-regular {
  font-family: "Kodchasan", serif;
  font-weight: 400;
  font-style: normal;
}

.kodchasan-medium {
  font-family: "Kodchasan", serif;
  font-weight: 500;
  font-style: normal;
}

.kodchasan-semibold {
  font-family: "Kodchasan", serif;
  font-weight: 600;
  font-style: normal;
}

.kodchasan-bold {
  font-family: "Kodchasan", serif;
  font-weight: 700;
  font-style: normal;
}

.kodchasan-extralight-italic {
  font-family: "Kodchasan", serif;
  font-weight: 200;
  font-style: italic;
}

.kodchasan-light-italic {
  font-family: "Kodchasan", serif;
  font-weight: 300;
  font-style: italic;
}

.kodchasan-regular-italic {
  font-family: "Kodchasan", serif;
  font-weight: 400;
  font-style: italic;
}

.kodchasan-medium-italic {
  font-family: "Kodchasan", serif;
  font-weight: 500;
  font-style: italic;
}

.kodchasan-semibold-italic {
  font-family: "Kodchasan", serif;
  font-weight: 600;
  font-style: italic;
}

.kodchasan-bold-italic {
  font-family: "Kodchasan", serif;
  font-weight: 700;
  font-style: italic;
}

@keyframes Zoom-in-out {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}
html,
body,
#root,
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  font-family: "Kodchasan", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: "Kodchasan", monospace;
}

.App {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/font.scss","webpack://./src/styles/index.scss","webpack://./src/styles/animations.scss","webpack://./src/styles/base.scss"],"names":[],"mappings":"AAEA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ACvEA;EACE;IACE,mBAAA;ED0EF;ECxEA;IACE,qBAAA;ED0EF;AACF;AEhFA;;;;;;EAME,SAAA;EACA,UAAA;AFkFF;;AEhFA;EACE,SAAA;EACA,oCAAA;EACA,mCAAA;EACA,kCAAA;AFmFF;;AEhFA;EACE,mCAAA;AFmFF;;AEhFA;EACE,kBAAA;AFmFF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Kodchasan:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap\");\n\n.kodchasan-extralight {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 200;\n  font-style: normal;\n}\n\n.kodchasan-light {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 300;\n  font-style: normal;\n}\n\n.kodchasan-regular {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.kodchasan-medium {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.kodchasan-semibold {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.kodchasan-bold {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.kodchasan-extralight-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 200;\n  font-style: italic;\n}\n\n.kodchasan-light-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 300;\n  font-style: italic;\n}\n\n.kodchasan-regular-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.kodchasan-medium-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.kodchasan-semibold-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.kodchasan-bold-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 700;\n  font-style: italic;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Kodchasan:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap\");\n.kodchasan-extralight {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 200;\n  font-style: normal;\n}\n\n.kodchasan-light {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 300;\n  font-style: normal;\n}\n\n.kodchasan-regular {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.kodchasan-medium {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.kodchasan-semibold {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.kodchasan-bold {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.kodchasan-extralight-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 200;\n  font-style: italic;\n}\n\n.kodchasan-light-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 300;\n  font-style: italic;\n}\n\n.kodchasan-regular-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.kodchasan-medium-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.kodchasan-semibold-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.kodchasan-bold-italic {\n  font-family: \"Kodchasan\", serif;\n  font-weight: 700;\n  font-style: italic;\n}\n\n@keyframes Zoom-in-out {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.1);\n  }\n}\nhtml,\nbody,\n#root,\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Kodchasan\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: \"Kodchasan\", monospace;\n}\n\n.App {\n  text-align: center;\n}","@keyframes Zoom-in-out {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.1);\n  }\n}\n","html,\nbody,\n#root,\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n}\nbody {\n  margin: 0;\n  font-family: \"Kodchasan\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: \"Kodchasan\", monospace;\n}\n\n.App {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
